// import { imageList } from './images';
import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes";
import "./assets/fonts/font-style.css";
import "./styles/global.css";
import { ToastProvider } from "react-toast-notifications";
import { PersistGate } from "redux-persist/integration/react";
import { persistor } from "./store/store";

function App() {
  return (
    <Router>
      <PersistGate loading={null} persistor={persistor}>
        <ToastProvider autoDismissTimeout={5000}>
          <AppRoutes />
        </ToastProvider>
      </PersistGate>
    </Router>
  );
}

export default App;
